import { Content } from "../__generated__/generated-gql-types"
import { TagGroup } from "../models/api"

export const useReportUtils = () => {

  const getReportTitle = (report: Content): string => {
    const DEFAULT_TITLE = '投研资讯'
    // 如果有title_prefix，从title中移除title_prefix + '-'
    const titlePrefix = report?.detail?.title_prefix || report?.title_prefix
    if (titlePrefix) {
      return report.title?.replace(`${titlePrefix}-`, '') || DEFAULT_TITLE
    }

    // 提取基础标题（最后一段）
    const parts = report?.title?.split('-')
    const baseTitle = parts?.length ? parts[parts.length - 1] : DEFAULT_TITLE

    return baseTitle
  }

  /**
   * 获取堆叠的标签
   * @param item
   */
  const getStackedTags = (item:Content) => {
    if (item.tag_relations?.some(tag => tag?.group === TagGroup.AI_GENERATED_CONTENT)) {
      return item.tags?.map(tag => {
        if (tag?.id === 657) {
          return 'Omen日报'
        } 
        return tag?.name
      })
    }
    
    const tags = item?.tags?.map(tag => tag?.name)?.filter(Boolean) ?? []
    
    return tags
  }

  return {
    getReportTitle,
    getStackedTags,
  }
}
